export default __webpack_public_path__ + "c0f1bb3908d55738108525d98e1f7730.png";